// Client side app startup file
// import 'babel-polyfill';
import { datadogRum } from '@datadog/browser-rum';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';

import Fingerprint2 from 'fingerprintjs2';
import Cookies from 'cookies-js';

import BaseApp from './helpers/BaseApp';
import makeStore from './helpers/createStore';

import Routes from '../shared/routes';

import * as serviceWorkerRegistration from '../serviceWorkerRegistration';

if (process.env.CONFIG_SOURCE === 'production' || process.env.CONFIG_SOURCE === 'prod') {
    datadogRum.init({
        applicationId: '61d4c69b-9399-4482-8673-32788b48cb20',
        clientToken: 'pubabd2ab75cecf17fdaf80d0479a811e78',
        site: 'us3.datadoghq.com',
        service: 'legacy-web',
        env: 'prod',
        // version: '1.0.0',
        allowedTracingUrls: ['https://api.utrsports.net', /https:\/\/.*\.utrsports\.net/, (url) => url.startsWith('https://api.utrsports.net')],
        sessionSampleRate: 10,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
    });
}

const store = makeStore();

new Fingerprint2().get((fingerprint) => {
    Cookies.set('_fingerprint', fingerprint, { domain: window.APP_HOST_NAME, secure: process.env.CONFIG_SOURCE === 'production' || process.env.CONFIG_SOURCE === 'prod' });
});

const renderApp = () => ReactDOM.hydrate(
    <BaseApp store={store} routes={Routes} />,
    document.querySelector('#root'),
);

renderApp();

if (module.hot) {
    module.hot.accept('../shared/routes', () => {
        renderApp();
    });
}

serviceWorkerRegistration.register();
